// dev test values
// export const GOOGLE_REDIRECT_URI = 'http://localhost:3100/letsgo/invite/signup/google'
// export const MICROSOFT_REDIRECT_URI = 'http://localhost:3100/letsgo/invite/signup/microsoft'

/* These are the real values we want to use for the redirect uris */
// import config from 'config'

import config from 'config/index'

export const GOOGLE_REDIRECT_URI = `${config.LETS_GO_URL}/letsgo/invite/signup/google`
export const MICROSOFT_REDIRECT_URI = `${config.LETS_GO_URL}/letsgo/invite/signup/microsoft`
